import { Box, Tab, Tabs, useTheme } from "@mui/material";
import { useCallback } from "react";
import { useSearchParams } from "react-router";
import FieldTabPanel from "./muiTabPanels/fieldTabPanel.component";
import SubAreasTabPanel from "./muiTabPanels/subAreasTabPanel.component";
import CropHistoryTabPanel from "./muiTabPanels/cropHistoryTabPanel.component";

const tabs = [
  { id: "terreno", label: "Terreno" },
  { id: "sottoterreni", label: "Sottoterreni" },
  { id: "storico", label: "Storico Colture" },
];

const MuiTabs = ({ onChange, field, sensors }) => {
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab");
  const selectedTabIndex = tabs.findIndex((tab) => tab.id === tabParam);
  const value = selectedTabIndex >= 0 ? selectedTabIndex : 0;

  const handleChange = useCallback(
    (event, newValue) => {
      const nextSearchParams = new URLSearchParams(searchParams);
      const nextTabId = tabs[newValue]?.id;

      if (nextTabId && newValue !== 0) {
        nextSearchParams.set("tab", nextTabId);
      } else {
        nextSearchParams.delete("tab");
      }

      setSearchParams(nextSearchParams, { replace: true });
      onChange?.(newValue, event);
    },
    [onChange, searchParams, setSearchParams]
  );

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column">
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="field-info-tabs"
        variant="fullWidth"
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.id}
            sx={{
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "bold",
              "&.Mui-selected": {
                backgroundColor: "primary.main",
                color: "white",
              },
            }}
            label={tab.label}
          />
        ))}
      </Tabs>
      {value === 0 && (
        <FieldTabPanel field={field} sensors={sensors} theme={theme} />
      )}
      {value === 1 && <SubAreasTabPanel field={field} theme={theme} />}
      {value === 2 && <CropHistoryTabPanel theme={theme} field={field} />}
    </Box>
  );
};

export default MuiTabs;
